<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="close()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <form (keydown.enter)="$event.preventDefault()" [formGroup]="detailForm">
    <div class="item-row">
      <div class="item-label">First Name</div>
      <div class="item-value">
        <input class="form-control" formControlName="firstName" placeholder="First Name" type="text">
        <dp-field-error [formField]="form['firstName']"></dp-field-error>
      </div>
      <div class="item-label">Last Name</div>
      <div class="item-value">
        <input class="form-control" formControlName="lastName" placeholder="Last Name" type="text">
        <dp-field-error [formField]="form['lastName']"></dp-field-error>
      </div>
    </div>
    <div class="item-row">
      <div class="item-label">Email</div>
      <div class="item-value">
        <input class="form-control" formControlName="email" placeholder="Email" type="text">
        <dp-field-error *ngIf="![companies.Seca].includes(company)" [formField]="form['email']"></dp-field-error>
      </div>
      <div class="item-label">Phone Number</div>
      <div class="item-value">
        <input class="form-control" formControlName="homePhone"
               placeholder="Only 10 digit numbers allowed"
               type="text"
               maxlength="10" minlength="10" pattern="^[0-9]{10}$">
        <dp-field-error [formField]="form['homePhone']"></dp-field-error>
      </div>
    </div>
    <ng-container *ngIf="customerType !== 'Customer'">
      <div *ngIf="[companies.Sea].includes(company)" class="item-row">
        <div class="item-label">Employee Number</div>
        <div class="item-value">
          <input class="form-control" formControlName="employeeNo" placeholder="Employee Number" type="text">
          <dp-field-error [formField]="form['employeeNo']"></dp-field-error>
        </div>
      </div>
    </ng-container>
    <div *ngIf="[companies.Seca].includes(company)" class="item-row">
      <div class="item-label">Language</div>
      <div class="item-value">
        <ng-select [items]="languages"
                   [multiple]="false"
                   bindLabel="name"
                   bindValue="code"
                   class="form-control"
                   formControlName="language"
                   id="language-input"
                   placeholder="Language">
        </ng-select>
        <dp-field-error [formField]="form['language']"></dp-field-error>
      </div>
    </div>
    <div *ngIf="customerType === 'Customer' || isStoreContact" class="item-row align-items-start h-auto">
      <div class="item-label">Address</div>
      <app-google-places-autocomplete [company]="company" [country]="country" [data]="customerData"
                                      [isCustomerDetailPage]="true"></app-google-places-autocomplete>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end w-100">
    <div class="d-flex">
      <button (click)="save()" *ngIf="isEditable && isCreate" class="btn btn-185px btn-outline-dark"
              type="button">Create
      </button>
      <button (click)="newContact()" *ngIf="!isCreate && isFromStoreContact" class="btn btn-185px btn-outline-dark" type="button">New</button>
      <button (click)="confirm()" *ngIf="!isCreate" class="btn btn-185px btn-dark ml-24px" type="button">Confirm</button>
    </div>
  </div>
</div>
